<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.65"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <path :d="paths[name] || paths.chart" />
  </svg>
</template>
<script>
const paths = {
  download: "M12 3v12 M7 10l5 5 5-5 M4 16v5h16v-5",
  monitor: "M3 4h18v14H3z M8 22h8 M12 18v4",
  chart: "M3 3v18h18 M7 15V9 M7 11h3v5H7 M14 12V4 M14 7h3v6h-3 M20 18v-6",
  arrow: "M4 12h16 M14 6l6 6-6 6",
  grid: "M3 3h7v7H3z M14 3h7v7h-7z M3 14h7v7H3z M14 14h7v7h-7z",
  layers: "M12 3l10 5-10 5L2 8z M2 12l10 5 10-5 M2 16l10 5 10-5",
  drawing: "M4 20l4-1L21 6l-3-3L5 16z M15 6l3 3 M3 21h18",
  indicator: "M2 14l4-4 4 8 4-14 4 10h4",
  ai: "M12 3l2.5 6.5L21 12l-6.5 2.5L12 21l-2.5-6.5L3 12l6.5-2.5z M20 2v4 M18 4h4",
  replay: "M4 4v16 M20 4L7 12l13 8z",
  orderflow: "M3 3v18h18 M4 5h8 M4 9h15 M4 13h10 M4 17h12",
  alert: "M5 17h14l-2-3V9a5 5 0 0 0-10 0v5z M10 21h4",
  code: "M8 6l-6 6 6 6 M16 6l6 6-6 6 M14 3l-4 18",
  cloud:
    "M7 18a5 5 0 1 1 1-10 6 6 0 0 1 11 1 4.5 4.5 0 0 1-1 9H7 M12 11v9 M9 17l3 3 3-3",
  check: "M5 12l4 4L19 6",
  sun: "M12 3v2 M12 19v2 M3 12h2 M19 12h2 M5 5l2 2 M17 17l2 2 M5 19l2-2 M17 7l2-2 M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0",
  moon: "M20 15A9 9 0 0 1 9 4a9 9 0 1 0 11 11",
  menu: "M4 6h16 M4 12h16 M4 18h16",
  close: "M6 6l12 12 M6 18L18 6",
  shield: "M12 3l8 3v6c0 5-8 9-8 9S4 17 4 12V6z M8 12l3 3 5-6",
  terminal: "M4 6l5 6-5 6 M12 18h8",
  wallet: "M3 6h17v15H3z M3 6l14-3v3 M16 11h6v5h-6z",
};
export default {
  props: { name: String, size: { default: 22 } },
  data: () => ({ paths }),
};
</script>
